import { Box, Stack, Typography } from "@mui/material";
import { IsMdScreen, IsXsScreen } from "helpers/hooks";
import { ResourceTypography } from "Modules/Marketing/Resources/Resources.styled";
import { Link as RouterLink } from "react-router-dom";
import { ShButton } from "shared/SharedStyles/ShInputs";
import { ShContainer } from "shared/SharedStyles/ShLayouts";
import CommonQuestionSidebar from "../CommonQuestionSidebar";

export const AccessLevelsHelp = () => {
  const isMdScreen = IsMdScreen();
  const paddingValue = IsXsScreen() ? 1 : 3;

  return (
    <>
      <Stack padding={paddingValue} direction={"row"}>
        <ShContainer maxWidth='xl' margin='auto'>
          <ResourceTypography variant="h5" fontWeight={"bold"} gutterBottom>
            Access Levels
          </ResourceTypography>
          <ResourceTypography variant="body1" paragraph>
            Manage user access levels and permissions to control what team members can do
            within the platform. Define roles and assign appropriate access rights.
          </ResourceTypography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Role Management
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Create and manage different roles with specific permissions. Assign roles to
            team members based on their responsibilities and access needs.
          </Typography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Permission Settings
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Configure detailed permissions for each role, controlling access to features,
            data, and actions within the platform. Set up granular access controls.
          </Typography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Team Access
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Manage team-wide access settings and permissions. Ensure team members have
            appropriate access to perform their job functions effectively.
          </Typography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Access Auditing
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Monitor and review access levels and permissions. Track changes to access
            rights and ensure compliance with security policies.
          </Typography>

          <Box paddingTop={2} paddingBottom={3}>
            <ShButton
              component={RouterLink}
              to="/employer/settings/account/access-levels"
              color="primary"
              variant="contained"
            >
              Manage Access Levels
            </ShButton>
          </Box>
        </ShContainer>
        {!isMdScreen && <CommonQuestionSidebar />}
      </Stack>
    </>
  );
};

export default AccessLevelsHelp; 